// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/leave-policies",
  Create: "/pyr/leave-policies",
  Update: "/pyr/leave-policies",
};
